module.exports = __webpack_public_path__ + "static/media/user.af88856f.jpg";